import { useRouter } from 'next/router';
import { SWRConfiguration } from 'swr';
import useTicketByKey from './useTicketByKey';

export default function useCurrentTicket(config: SWRConfiguration = {}) {
    const {
        query: { ticketKey }
    } = useRouter();

    return useTicketByKey(ticketKey?.toString(), config);
}
